// import consts
import { dynamicAssets } from 'js/constants/Paths';

export const parseData = (data) => {
  const characterIds = [];
  const charactersById = {};

  if (data) {
    data.map((item, index) => {
      item.previousItem = false;
      item.nextItem = false;
      // get previous item if avaiable
      const previousItem = data[index - 1] || false;

      // get next item if avaiable
      const nextItem = data[index + 1] || false;

      if (previousItem) {
        item.previousItem = {
          name: previousItem.name,
          friendly_url: '/meet-the-characters/' + previousItem.friendly_url,
        };
      }

      if (nextItem) {
        item.nextItem = {
          name: nextItem.name,
          friendly_url: '/meet-the-characters/' + nextItem.friendly_url,
        };
      }
      item.displayInCarousel = true;

      if (item.header_image && item.header_image !== '') {
        item.header_image = dynamicAssets(item.header_image);
      }

      if (item.cta_image && item.cta_image !== '') {
        item.cta_image = dynamicAssets(item.cta_image);
      }

      if (item.character_image && item.character_image !== '') {
        item.character_image = dynamicAssets(item.character_image);
      }

      if (item.fun_fact_image && item.fun_fact_image !== '') {
        item.fun_fact_image = dynamicAssets(item.fun_fact_image);
      }

      item.full_url = '/meet-the-characters/' + item.friendly_url;

      characterIds.push(item.id);
      charactersById[item.id] = item;
    });
  }

  return { charactersById, characterIds };
};
